import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { ApolloLink, ServerError } from '@apollo/client'

// https://www.apollographql.com/docs/react/api/link/apollo-link-context

const withToken = setContext(() => {
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  console.log('~~~~~~ WILL ADD TOKEN', token)
  return { token }
})

const resetToken = onError(({ networkError }) => {
  if (networkError && networkError.name === 'ServerError' && (networkError as ServerError).statusCode === 401) {
    sessionStorage.clear()
    window.location.replace('/')
  }
})

/**
 * Adds the Authorization/Bearer header
 */
const addAuthHeaderLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {}, token = null }) => {
    return {
      headers: {
        ...headers,
        ...(token
          ? {
              authorization: `Bearer ${token}`,
            }
          : {}),
      },
    }
  })
  return forward(operation)
})

export const authFlowLink = withToken.concat(addAuthHeaderLink).concat(resetToken)
